<script setup lang="ts">
    import type { ButtonProps } from '@/types/components/button';
    import { computed } from 'vue';

    const props = withDefaults(defineProps<ButtonProps>(), {
        disabled: false,
        loading: false
    });

    const classes = computed(() => {
        const base = 'px-4 rounded-[10px] flex items-center justify-center w-full';

        const size = {
            large: 'py-2.5',
            medium: 'py-2',
            small: 'py-1.5'
        };

        const type = {
            primary: 'bg-transparent text-brand hover:bg-brand-hover cursor-pointer',
            warning: 'bg-transparent text-warning-600 hover:bg-warning-50 cursor-pointer',
            danger: 'bg-transparent text-negative hover:bg-negative-hover cursor-pointer',
            success: ''
        };

        return [
            base,
            size[props.size],
            props.loading && 'opacity-50 !cursor-not-allowed',
            props.disabled && 'text-disabled bg-disabled-button !cursor-not-allowed',
            !props.disabled && !props.loading && type[props.type]
        ];
    });
</script>

<template>
    <button :disabled="props.disabled" @click="props.onClick" :class="classes">
        <slot />
    </button>
</template>
